<template>
  <el-dialog
    title="支付密码设置"
    :visible.sync="visible"
    width="400px" 
    class="password"
    >
      <div v-if="passwordFlag == 0">
        <div class="set_psw">
          <span>密码：</span>
          <el-input 
            :type="pswOnoff.look1?'password':'text'" 
            v-model.tirm="params.secondPassword" 
            class="w_100"  
            size="small"  
          >
            <i 
              @click="pswOnoff.look1 = !pswOnoff.look1"
              slot="append" 
              :class="pswOnoff.look1?'el-icon-view':'el-icon-view'" 
              class="icon_btn">
            </i>
            <span 
              v-if="pswOnoff.look1" 
              slot="append" 
              class="icon_line">
            </span>
          </el-input>
        </div>
        <div class="set_psw" >
          <span>确认密码：</span>
          <el-input 
            :type="pswOnoff.look2?'password':'text'" 
            v-model.tirm="params.password" 
            class="w_100"  
            size="small"  
          >
            <i 
              @click="pswOnoff.look2 = !pswOnoff.look2"
              slot="append" 
              :class="pswOnoff.look2?'el-icon-view':'el-icon-view'" 
              class="icon_btn">
            </i>
            <span 
              v-if="pswOnoff.look2" 
              slot="append" 
              class="icon_line">
            </span>
          </el-input>
        </div>
      </div>
      <p class="box_p" v-else>支付密码已设置、如遗忘密码请联系我司商务重置</p>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="passwordFlag == 0"
      >
        <el-button
          type="primary"
          @click="handleSave"
          size="small"
        >保存</el-button>
      </span>
  </el-dialog>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data(){
    return {
      visible:false,
      pswOnoff:{
        look1:true,
        look2:true,
      },
      params:{
        secondPassword:'',
        passwordFlag:1,
        userId:this.$store.state.LOGINUSER.id,
        password:''
      }
    }
  },
  computed:{
    //获取支付状态
    passwordFlag(){
      return this.$store.state.passwordFlag;
    }
  },
  methods:{
    ...mapMutations(['SET_PASSWORD_FLAG']),
    //保存
    async handleSave(){
      let params = Object.assign({},this.params);
      delete params.password;
      if(this.params.password != this.params.secondPassword){
        this.$message({
          type:'success',
          message:'两次密码不一致'
        });
        return false;
      }
      const { data } = await this.$API.setSecondPassword(params);
      if(data.code == 0){
        this.$message({
          type:'success',
          message:data.msg
        })
        this.SET_PASSWORD_FLAG(1);
        // this.getUserPsw();
        this.visible = false;
      }else{
        this.$message({
          type:'warning',
          message:data.msg
        })
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.password{
  .set_psw{
    margin-bottom: 10px;
    padding: 0 20px;
    position: relative;
    .icon_btn{
      cursor: pointer;
    }
    .icon_line{
      position: absolute;
      right: 17px;
      display: block;
      width: 20px;
      height: 1px;
      top: 15px;
      background: #999;
      transform:rotateZ(32deg);
    }
    >span{
      display: inline-block;
      width: 100px;
    }
    .w_100{
      width: 200px;
      margin-right: 10px;
    }
  }
  .box_p{
    color:#d61c1c;
    margin: 10px 0;
    text-align: center;
  }
  /deep/.el-dialog__body{
    padding: 10px;
  }
  /deep/.el-dialog__footer{
    padding: 10px;
    padding-top: 0;
    text-align: right;
  }
}
</style>